
export default class DynamicFieldDetail {
    FieldNo: number;
    FieldValue: string;

    constructor(FieldNo: number, FieldValue: string) {
        this.FieldNo = FieldNo;
        this.FieldValue = FieldValue;
    }
}